export const getScrollParams = (search?: string) => {
    const searchParams = new URLSearchParams(
        search ?? window?.top?.location.search ?? ''
    );
    const scrollToFirstPendingTag = !!searchParams.get(
        'scrollToFirstPendingTag'
    );
    const scrollToTagID = Number(searchParams.get('scrollToTagID'));
    const scrollToProductID = Number(searchParams.get('scrollToProductID'));
    const scrollToImageID = Number(searchParams.get('scrollToImageID'));

    return {
        scrollToFirstPendingTag,
        scrollToTagID,
        scrollToProductID,
        scrollToImageID,
    };
};
